export const TOGGLE_SIDEBAR = "[UI] toggle sidebar";

export const toggleSidebar = () => {
  return {
    type: TOGGLE_SIDEBAR,
  };
};